/* eslint-disable max-len */
/**
 * @file 独立页面
 * @author izzieyspu
 */

import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { Route, Switch, BrowserRouter, Redirect } from 'react-router-dom';
import { Loading } from '@tencent/ptp-fe-common';
import loadable from '@loadable/component';
import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import commonReport from '@/common/common-report';
import { getAccountInfo } from '@/api/operator/cgi/smb/common';
import globalStore from '@/stores';
import Skeleton from '@/common-components/skeleton';
import { REACT_APP_PUBLIC_URL } from '@/constants/Constants';

dayjs.extend(duration);

const routes = [
  {
    key: 'ai-report-view',
    href: '/ai-report-view',
    label: 'AI报表查看',
    pageModule: ['AI 助理'],
    component: loadable(() => import(/* webpackChunkName: 'ai-report' */ /* webpackMode: 'lazy' */ '@/ai-assistant/modules/ai-report-view'), { fallback: <Loading /> }),
  },
];

/** single 应用 basename，与 dev/nginx 回退到 single 的路径一致 */
export const SINGLE_BASENAME = `${REACT_APP_PUBLIC_URL}/single`;

export const SINGLE_PATH_MAP = routes.reduce((map: Record<string, string[]>, v: any) => ({
  ...map,
  [`/single${v.href}`]: [...v.pageModule || [], v.label],
}), {});

const Content: React.FC = () => {
  return (
    <div id="main">
      <BrowserRouter basename={SINGLE_BASENAME}>
        <Switch>
          {
            routes.map((v: any) => {
              return (
                <Route
                  key={v.href}
                  path={v.href}
                  component={v.component}
                />
              );
            })
          }
        </Switch>
      </BrowserRouter>
    </div>
  );
};

const Single: React.FC = () => {
  const { account } = globalStore;
  const [loading, setLoading] = useState(true);

  // 数据上报到reporthub
  useEffect(() => {
    getAccountInfo().then((res) => {
      commonReport.setLoginStatus(res?.data || {});
      globalStore.setAccount(res?.data || {});
    })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <Skeleton showTopNav={true} />;
  }
  if (_.isEmpty(account)) {
    return null;
  }
  return <Content />;
};

export default Single;
